import { handleRetrieveSingleBlog } from "../../../redux/public-slices/blog.slice";
import { Link, Link as NavLink, useLocation, useParams } from "react-router-dom";
import { refresher, showDialog } from "../../../redux/guest-slices/other.slice";
import { ShareButtons } from "../../../components/common/dialogs/ShareButtons";
import { Fragment, lazy, Suspense, useEffect, useRef, useState } from "react";
import { createComment } from "../../../redux/guest-slices/common.slice";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import { checkUserType, FILE_PATH_URI } from "../../../utils/helper";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import InputField1 from "../../../components/ui/InputField1";
import { useDispatch, useSelector } from "react-redux";
import { GUEST_LOGIN } from "../../../utils/keywords";
import Comment from "../../../components/ui/Comment";
import { useToast } from "../../../hooks/useToast";
import Images from "../Home/temp-data/Images";
import Icons from "../../../assets/js/Icons";
import Aside from "./Category/Aside";
import Related from "./Related";
import moment from "moment";

import {
  Alert, Avatar, Box, Button, Chip, Container, Divider, Grid2 as Grid, IconButton,
  List, ListItem, ListItemIcon, ListItemText, Skeleton, Stack, Typography,
} from "@mui/material";

const TopBannerA = lazy(() => import("../../../components/common/TopBannerA"));

function SingleBlog() {
  const toast = useToast();
  const dispatch = useDispatch();
  const { blogId } = useParams();
  const location = useLocation();
  const commentRef = useRef(null);
  const [blog, setBlog] = useState({});
  const route = location.pathname?.split("/")?.[2];
  const [reply, setReply] = useState({ id: null, view: false });
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const { refresh, loadings } = useSelector((state) => state.otherSlice);
  const location2 = window.location.origin;

  // Handle add comment
  const handleAddComment = async (isDraft) => {
    const formData = {
      blogId,
      isDraft,
      description: commentRef.current?.value,
    };
    if (!formData?.description || formData?.description?.trim() === "") {
      return toast.error("Please enter comment!");
    }
    const response = await dispatch(createComment(formData));
    if (createComment.fulfilled.match(response)) {
      if (commentRef.current) {
        commentRef.current.value = "";
      }
      dispatch(refresher());
    }
  };

  // "http://localhost:3000"

  // Handle guest login
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN));
  };

  // Handle get all blogs
  const handleRetrieve = async () => {
    const { blog } =
      (await dispatch(handleRetrieveSingleBlog(blogId)).unwrap()) || {};
    setBlog(blog);
  };

  const handleShareClick = () => {
    setShareDialogOpen(true);
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        handleRetrieve();
      }, 1500);
    } else {
      handleRetrieve();
    }
    // eslint-disable-next-line
  }, [refresh, route]);
  const shareUrl = `${location2}/${blog?._id}`;

  const handleFacebookShare = () => {
    try {
      const fbUrl = new URL("https://www.facebook.com/sharer/sharer.php");

      fbUrl.searchParams.append("u", shareUrl);
      fbUrl.searchParams.append("quote", blog?.title || "Check this out!");

      const popup = window.open(
        fbUrl.toString(),
        "facebook-share-dialog",
        "width=626,height=436,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no"
      );

      if (popup) {
        popup.focus();
      } else {
        console.error("Popup blocked or failed to open");
      }
    } catch (error) {
      console.error("Facebook share error:", error);
    }
  };
  const handleTwitterShare = () => {
    try {
      const twitterText = blog?.title || "Check out this forum post!";
      const params = new URLSearchParams({
        url: shareUrl,
        text: twitterText,
        hashtags: "forum,discussion",
      });

      const twitterUrl = `https://x.com/intent/tweet?${params.toString()}`;
      const popup = window.open(
        twitterUrl,
        "twitter-share-dialog",
        "width=626,height=436,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no"
      );

      if (popup) {
        popup.focus();
      } else {
      }
    } catch (error) {
      console.error("X share error:", error);
    }
  };

  const handleLinkedInShare = () => {
    try {
      const linkedInText = blog?.title || "Check out this blog!";
      const params = new URLSearchParams({
        url: shareUrl,
        title: linkedInText,
        summary: blog?.description?.replace(/<[^>]+>/g, "").slice(0, 200), // strip HTML, limit chars
        source: window.location.hostname,
      });

      const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?${params.toString()}`;

      const popup = window.open(
        linkedInUrl,
        "linkedin-share-dialog",
        "width=626,height=436,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no"
      );

      if (popup) {
        popup.focus();
      }
    } catch (error) {
      console.error("LinkedIn share error:", error);
    }
  };
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          currentPage={blog?.title || "Blog Page"}
          bannerImg={blog?.image || Images?.forumImg4}
          heading={blog?.title || "Blog Page"}
          menus={[{ name: "Blog ", path: "/blogs" }]}
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, laptop: 8 }}>
              <Box
                sx={{
                  ml: "auto",
                  maxWidth: "1000px",
                  height: "fit-content",
                  position: "sticky",
                  top: 20,
                  overflowY: "auto",
                }}
              >
                {loadings?.retrieveSingle ? (
                  <Skeleton
                    sx={{
                      width: "100%",
                      minHeight: 350,
                      transform: "none",
                    }}
                  />
                ) : !blog ? (
                  <Alert
                    sx={{
                      fontSize: "20px",
                      fontWeight: "500",
                      alignItems: "center",
                      fontFamily: "Poppins",
                      ".MuiAlert-message": { p: "0" },
                      ".MuiAlert-icon": { fontSize: "28px" },
                    }}
                    color="error"
                    severity="error"
                  >
                    No Records Found!
                  </Alert>
                ) : (
                  <>
                    <Button
                      sx={{
                        minWidth: "120px",
                        width: "fit-content",
                        justifyContent: "center",
                        textTransform: "uppercase",
                        transition: "all 350ms ease",
                        ":hover": {
                          color: "white",
                          bgcolor: "secondary.dark",
                        },
                      }}
                      size="small"
                      color="secondary"
                      variant="outlined"
                      LinkComponent={NavLink}
                      to={`/blog-category/${blog?.category?._id || blog?.categoryId}`}
                    >
                      {blog?.category?.name || "Uncategorized"}
                    </Button>
                    <Divider sx={{ my: 2 }} />
                    <Box
                      sx={{
                        gap: 2,
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Stack
                        spacing={2}
                        direction="row"
                        sx={{
                          alignItems: "center",
                          flexWrap: { xs: "wrap" },
                        }}
                        divider={<Divider flexItem orientation="vertical" />}
                      >
                        <Avatar
                          sx={{ width: 35, height: 35 }}
                          src={blog?.user?.image}
                        />
                        <Typography
                          fontWeight="600"
                          color="other.color1"
                          textTransform="capitalize"
                        >
                          {blog?.user?.fullName}
                        </Typography>
                      </Stack>

                      <Divider
                        flexItem
                        orientation="vertical"
                        sx={{
                          display: { xs: "none", sm: "block" },
                        }}
                      />

                      <Stack
                        spacing={2}
                        direction="row"
                        sx={{
                          alignItems: "center",
                          flexWrap: { xs: "wrap" },
                        }}
                        divider={<Divider flexItem orientation="vertical" />}
                      >
                        <Typography
                          fontWeight="500"
                          color="other.color2"
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {moment(blog?.createdAt).format("MMM DD YYYY")}
                        </Typography>
                        <Typography
                          color="other.color2"
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {blog?.comments || 0} Comments
                        </Typography>
                        <Typography
                          color="other.color2"
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {blog?.views || 0} Views
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider sx={{ mt: 2 }} />

                    <Typography
                      sx={{
                        my: 2,
                        width: "100%",
                        overflow: "hidden",
                        WebkitLineClamp: 1,
                        color: "other.color1",
                        display: "-webkit-box",
                        // WebkitBoxOrient: "vertical",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                      fontSize={28}
                      fontWeight="700"
                    >
                      {blog?.title}
                    </Typography>

                    <Box
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "6px",
                        aspectRatio: "1/0.5",
                      }}
                    >
                      <SkeletonImage src={FILE_PATH_URI + (blog?.banner?.path || blog?.banner?.source || "")} />
                    </Box>

                    <Box
                      sx={{ color: "other.color1" }}
                      dangerouslySetInnerHTML={{ __html: blog?.description }}
                    />

                    <Divider />

                    <Grid container spacing={2} my={2}>
                      <Grid size={{ xs: 12, md: "grow" }}>
                        {blog?.tags?.length > 0 && (
                          <Box
                            sx={{
                              gap: 2,
                              display: "flex",
                              flexWrap: { xs: "wrap", md: "nowrap" },
                            }}
                          >
                            <ListItem
                              component="div"
                              sx={{ p: "0", width: "auto" }}
                            >
                              <ListItemIcon
                                sx={{
                                  mr: 1,
                                  fontSize: "22px",
                                  minWidth: "auto",
                                  color: "secondary.dark",
                                  transform: "rotateY(180deg)",
                                }}
                              >
                                <Icons.TagSolid />
                              </ListItemIcon>

                              <ListItemText
                                sx={{
                                  m: "0",
                                  span: {
                                    fontWeight: "500",
                                    color: "other.color1",
                                  },
                                }}
                              >
                                Tags
                              </ListItemText>
                            </ListItem>
                            <List
                              sx={{
                                p: "0",
                                gap: 1,
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              {blog?.tags?.map((tag, i) => (
                                <Chip
                                  key={i}
                                  size="small"
                                  label={tag}
                                  component={ListItem}
                                  variant="CommentChip"
                                  sx={{ width: "auto" }}
                                />
                              ))}
                            </List>
                          </Box>
                        )}
                      </Grid>
                      <Grid size={{ xs: 12, md: "auto" }}>
                        <Stack spacing={2} direction="row">
                          <IconButton
                            size="small"
                            component={Link}
                            onClick={handleFacebookShare}
                          >
                            <Icons.Facebook />
                          </IconButton>
                          <IconButton size="small" onClick={handleTwitterShare}>
                            <Icons.TwitterX />
                          </IconButton>

                          <IconButton
                            size="small"
                            onClick={handleLinkedInShare}
                          >
                            <Icons.LinkedIn />
                          </IconButton>

                          <IconButton
                            size="small"
                            onClick={() => handleShareClick()}
                          >
                            <Icons.PlusSolid />
                          </IconButton>
                        </Stack>
                      </Grid>
                    </Grid>
                  </>
                )}

                <Related currentBlogId={blog._id} id={blog?.category?._id || blog?.categoryId} />

                <Box>
                  <Box textAlign="center" mb={3}>
                    <Typography
                      fontSize={28}
                      fontWeight="700"
                      textAlign="center"
                      color="other.color1"
                    >
                      Leave a Comment
                    </Typography>
                    <Divider
                      sx={{
                        mt: 2,
                        mx: "auto",
                        maxWidth: "200px",
                        borderWidth: "1.5px",
                        borderColor: "secondary.main",
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      background: "white",
                      p: "16px",
                    }}
                  >
                    <InputField1
                      name="comment"
                      type="textarea"
                      inputRef={commentRef}
                      placeholder="Write your comment here.."
                    />
                  </Box>
                  <Box textAlign="end" mt={2}>
                    {!checkUserType() ? (
                      <Button variant="contained" onClick={handleLogin}>
                        Login to comment
                      </Button>
                    ) : (
                      <Fragment>
                        <Stack
                          direction={{ xs: "column", md: "row" }}
                          sx={{
                            gap: { xs: 2, sm: 2, md: 15 },
                          }}
                        >
                          <Button
                            size="large"
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              handleAddComment(false);
                            }}
                            sx={{
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            Post Comment
                          </Button>
                          <Button
                            size="large"
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              handleAddComment(true);
                            }}
                            sx={{
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            Save Draft
                          </Button>
                        </Stack>
                      </Fragment>
                    )}
                  </Box>
                  {blog?.blogComments && (
                    <Comment
                      reply={reply}
                      setReply={setReply}
                      comments={blog?.blogComments}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, laptop: 4 }}>
              <Box
                sx={{
                  py: 8,
                  px: 3,
                  gap: 10,
                  height: "100%",
                  display: "flex",
                  borderRadius: 2,
                  bgcolor: "#EBF5F5",
                  flexDirection: "column",
                  boxShadow: "0 0 10px 0 #0000000a",
                }}
              >
                <Aside blog={blog} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <ShareButtons
        open={shareDialogOpen}
        onClose={handleShareDialogClose}
        url={shareUrl}
        title={blog?.title}
      />
    </Fragment>
  );
}

export default SingleBlog;
